<template>
  <layouts-header></layouts-header>
  <layouts-sidebar></layouts-sidebar>
  <div class="page-wrapper meter-opp">
    <div class="content">
      <div class="row">
        <div class="col-md-12">
          <div class="contact-head">
            <div class="row align-items-center">
              <div class="col-sm-6">
                <ul class="contact-breadcrumb">
                  <li>
                    <router-link
                      :to="{
                        path: '/crm/organisation-details',
                        query: { ter_Id: terId, org_Id: orgId, for: 'support-cases' },
                      }"
                    >
                      <i class="ti ti-arrow-narrow-left"></i>
                      Organisation
                    </router-link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-xl-12">
              <div class="card">
                <div class="card-body settings-form">
                  <Form @submit="createCase" :validation-schema="schema">
                    <div class="row align-items-center mb-3">
                      <div class="col-6"><h4>Create Support Case</h4></div>
                    </div>
                    <div class="row">
                      <div class="col-md-4">
                        <div class="form-wrap">
                          <label class="col-form-label">Type</label>
                          <Field as="select" name="ticket_type" class="form-select" v-model="form.ticket_type">
                            <option value="">-----Select-----</option>
                            <option v-for="opt in typeOptions" :key="opt.value" :value="opt.value">{{ opt.text }}</option>
                          </Field>
                        </div>
                      </div>
                      <div class="col-md-4">
                        <div class="form-wrap">
                          <label class="col-form-label">Status</label>
                          <Field as="select" name="status" class="form-select" v-model="form.status">
                            <option value="">-----Select-----</option>
                            <option v-for="opt in statusOptions" :key="opt.value" :value="opt.value">{{ opt.text }}</option>
                          </Field>
                        </div>
                      </div>
                      <div class="col-md-4">
                        <div class="form-wrap">
                          <label class="col-form-label">Source</label>
                          <Field as="select" name="source" class="form-select" v-model="form.source">
                            <option value="">-----Select-----</option>
                            <option v-for="opt in sourceOptions" :key="opt.value" :value="opt.value">{{ opt.text }}</option>
                          </Field>
                        </div>
                      </div>
                      <div class="col-md-4">
                        <div class="form-wrap">
                          <label class="col-form-label">Action</label>
                          <Field as="select" name="action" class="form-select" v-model="form.action">
                            <option value="">-----Select-----</option>
                            <option v-for="opt in actionOptions" :key="opt.value" :value="opt.value">{{ opt.text }}</option>
                          </Field>
                        </div>
                      </div>
                      <div class="col-md-4">
                        <div class="form-wrap">
                          <label class="col-form-label">Deadline <span class="text-danger">*</span></label>
                          <Field name="deadline" type="datetime-local" class="form-control" v-model="form.deadline" />
                          <ErrorMessage name="deadline" class="text-danger" />
                        </div>
                      </div>
                      <div class="col-md-4">
                        <div class="form-wrap">
                          <label class="col-form-label">Responsible</label>
                          <Field as="select" name="responsible" class="form-select" v-model="form.responsible">
                            <option value="">-----Select-----</option>
                            <option v-for="res in responsibleOptions" :key="res.id" :value="res.id">{{ res.name }}</option>
                          </Field>
                        </div>
                      </div>
                      <div class="col-md-4">
                        <div class="form-wrap">
                          <label class="col-form-label">Contact person</label>
                          <Field as="select" name="contact_person" class="form-select" v-model="form.contact_person">
                            <option value="">-----Select-----</option>
                            <option v-for="p in orgPersons" :key="p.id" :value="p.id">{{ p.name }}</option>
                          </Field>
                        </div>
                      </div>
                      <div class="col-md-8">
                        <div class="form-wrap">
                          <label class="col-form-label">Subject</label>
                          <Field name="subject" type="text" class="form-control" v-model="form.subject" />
                        </div>
                      </div>
                      <div class="col-md-12">
                        <div class="form-wrap">
                          <label class="col-form-label">Description</label>
                          <Field as="textarea" name="description" class="form-control" rows="3" v-model="form.description" />
                        </div>
                      </div>
                      <div class="col-md-12">
                        <div class="form-wrap">
                          <label class="col-form-label">Email CC</label>
                          <Field name="email_cc" type="text" class="form-control" v-model="form.email_cc" />
                        </div>
                      </div>
                      <div class="col-md-12">
                        <div class="form-wrap">
                          <label class="col-form-label">Log note</label>
                          <Field as="textarea" name="content" class="form-control" rows="2" v-model="form.content" />
                        </div>
                      </div>
                    </div>
                    <div class="text-end">
                      <button type="submit" class="btn btn-primary">Save</button>
                    </div>
                  </Form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, computed, onMounted } from 'vue';
import { useStore } from 'vuex';
import { useRoute, useRouter } from 'vue-router';
import { Form, Field, ErrorMessage } from 'vee-validate';
import * as Yup from 'yup';

export default {
  components: { Form, Field, ErrorMessage },
  setup() {
    const store = useStore();
    const route = useRoute();
    const router = useRouter();
    const orgId = ref(route.query.org_Id || null);
    const terId = ref(route.query.ter_Id || null);
    const orgPersons = ref([]);
    const dropdowns = computed(() => store.getters['orgSupportCases/getOrgSupportCaseDropdowns'] || {});
    const typeOptions = computed(() => dropdowns.value.support_type || []);
    const statusOptions = computed(() => dropdowns.value.support_status || []);
    const actionOptions = computed(() => dropdowns.value.support_action || []);
    const sourceOptions = computed(() => dropdowns.value.support_source || []);
    const responsibleOptions = computed(() => store.getters['organisation/getresUsersOptions'] || []);

    const form = ref({
      organization_id: orgId.value,
      ticket_type: 'Complaint',
      status: 'Open',
      source: '',
      action: '',
      deadline: '',
      responsible: '',
      contact_person: '',
      subject: '',
      description: '',
      email_cc: '',
      content: '',
    });

    const schema = Yup.object({
      deadline: Yup.string().required('Deadline is required'),
    });

    const createCase = async () => {
      const payload = { ...form.value, organization_id: orgId.value };
      const res = await store.dispatch('orgSupportCases/createOrgSupportCase', payload);
      if (res?.status) {
        router.push({
          path: '/crm/organisation-details',
          query: { ter_Id: terId.value, org_Id: orgId.value, for: 'support-cases' },
        });
      }
    };

    onMounted(async () => {
      await store.dispatch('orgSupportCases/fetchOrgSupportCaseOptions');
      if (terId.value) {
        await store.dispatch('organisation/fetchTerritoryCompanyUsers', terId.value);
      }
      if (orgId.value) {
        orgPersons.value = (await store.dispatch('opportunity/fetchPersons', orgId.value)) || [];
      }
    });

    return {
      form,
      schema,
      createCase,
      orgId,
      terId,
      typeOptions,
      statusOptions,
      actionOptions,
      sourceOptions,
      responsibleOptions,
      orgPersons,
    };
  },
};
</script>
